import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-viewer',
  templateUrl: './viewer.component.html',
  styleUrls: ['./viewer.component.scss']
})
export class ViewerComponent implements OnInit {
  @Input() documentUrl: any;
  @Output() closeModal = new EventEmitter<void>();
  totalPages: number = 0;
  safeUrl: SafeResourceUrl | undefined;

  constructor(private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    if (this.documentUrl) {
      console.log('ViewerComponent URL:', this.documentUrl);
      this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.documentUrl);

    }
  }

  isImage(url: string | undefined): boolean {
    return !!url && url.toLowerCase().match(/\.(jpeg|jpg|gif|png)$/) != null;
  }

  isPdf(url: string | undefined): boolean {
    return !!url && url.toLowerCase().endsWith('.pdf');
  }

  closeDialog() {
    this.closeModal.emit();
  }

  pdfLoaded(pdf: any): void {
    this.totalPages = pdf.numPages;
  }
}
